import { connect } from 'react-redux';
import AppHeader from './AppHeader';

const mapStateToProps = state => {
  const person = state.authentication.person;

  const preferOfficialPhotos =
    state.settings && state.settings.directory
      ? state.settings.directory.preferOfficialPhotos
      : false;

  const pictureUrl = preferOfficialPhotos ? person.officialPictureUrl : person.pictureUrl;

  return { person, pictureUrl };
};

export default connect(mapStateToProps)(AppHeader);
